import React, { Component } from 'react';
import apple_icon from "./app_icons/apple.jpg"
import android_icon from "./app_icons/android.png"

class Footer extends Component {
  render() {
    return (
      <div className="container">
        <div className="footer">
          <hr />
          <a className="footerLink" href={process.env.REACT_APP_APPLE_APP_URL}>
            <img src={apple_icon} alt="download on the app store" />
          </a>
          <a className="footerLink androidLink" href={process.env.REACT_APP_ANDROID_APP_URL}>
            <img src={android_icon} alt="get it on google play" />
          </a>
        </div>
      </div>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js